<template>
<div class="chapter">
<div class="inner_page">
<span epub:type="pagebreak" id="page28" title="28">
<figure>
<img alt="" class="fullpage" id="cover" src="images/pg29.png"/>
</figure>
</span>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page028.vue?6df0511c